<template>
    <div v-if="period">
        <b-modal
            v-model="show_modal_local"
            :title="'Реактирование периода'"
            class="modal-primary"
            size="md"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <div class="row">
                <div class="col col-6">
                    <b-form-group label="начало периода">
                        <v-date-picker
                            v-model='_period_start'
                            id="period_start"
                            name="period_start"
                            data-vv-as="'начало периода'"
                            :state="validateState('period_start')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="period_start_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>
                </div>
                <div class="col col-6">
                    <b-form-group label="окончание периода">
                        <v-date-picker
                            v-model='_period_end'
                            id="period_end"
                            name="period_end"
                            data-vv-as="'окончание периода'"
                            :state="validateState('period_end')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="period_end_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>
                </div>
                <div class="col col-12">
                    <b-form-group label="Наименование периода">
                        <input
                            class="form-control"
                            type="
                        text" v-model="period.title"
                            v-validate="{ required:true,max:200 }"
                            name="title"
                            data-vv-as="'Наименование периода'">
                    </b-form-group>
                </div>
            </div>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_hotel } from '@/functions/hotel';
    import { functions_period } from '@/functions_period';

    export default {
        name: 'PeriodEditDialog',
        mixins: [functions, functions_hotel, functions_period],
        data: function () {
            return {
            };
        },
        model: {
            prop: "period_id",
            event: "hide"
        },
        props: {
            period_id: Number,
            hotel_prop: Object,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                let self = this;
                this.savePeriod(function(self){
                    let hotelPeriod = self.findElementByID(self.hotel.periods, self.period.id);
                    console.log('handleOk hotelPeriod=',hotelPeriod);
                    if (self.is(hotelPeriod)) {
                        hotelPeriod.title = self.period.title;
                        hotelPeriod.date_period_begin_iso = self.period.date_period_begin_iso;
                        hotelPeriod.date_period_end_iso = self.period.date_period_end_iso;
                    }
                    self.$emit("changed", self.period.id);
                    self.$emit("hide", 0);
                }, self);
            },
        },
        computed: {
            show_modal_local: {
                get: function () {
                    return this.is(this.period);
                },
                set: function (newValue) {}
            },

            _period_start : {
                get: function () {
                    if (!this.is(this.period.date_period_begin_iso)) return null;
                    return new Date(this.period.date_period_begin_iso.slice(0, 10));
                },
                set: function (v) {
                    this.period.date_period_begin_iso = dateToISO(v);
                }
            },

            _period_end : {
                get: function () {
                    if (!this.is(this.period.date_period_end_iso)) return null;
                    return new Date(this.period.date_period_end_iso.slice(0, 10));
                },
                set: function (v) {
                    this.period.date_period_end_iso = dateToISO(v);
                }
            },


    },
        created: function() {
            this.hotel = this.hotel_prop;
            this.loadPeriod(this.period_id);
        },
    }
</script>
